/* projects/speaker-platform/src/app/pages/dashboard/dashboard.component.scss */
.dashboard h2 {
  padding-bottom: 8px;
}
.dashboard h2 span {
  font-size: 18px;
  font-style: italic;
  color: #818181;
  font-weight: 400;
}
.dashboard__ongoingseances__item:not(:last-of-type) {
  border-bottom: 1px solid #818181;
  margin-bottom: 8px;
  padding-bottom: 8px;
}
.dashboard .validStatus {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/*# sourceMappingURL=dashboard.component-VRZNTPGT.css.map */
